/*
  LittleG Explore / Workspace Runtime
  Version: V95 Workspace Contract Pack

  Contract:
  - Explore Router chooses route.
  - Lab Card starts tool.
  - Place Preview emits place selection state.
  - Mission runtime emits mission start and completion state.
  - This runtime synchronizes workspace state; it does not own persistence truth.
*/


/* =========================================================
   PAGE 08 — /pages/littleg Explore Nintendo Shell
   Existing page: templates/page.littleg.json
   Rule: no CSS inside JS.
   ========================================================= */
(function () {
  'use strict';

  var initialized = new WeakSet();

  var MODE_COPY = {
    missions: {
      label: 'LittleG Mission Mode',
      focus: '0.01% City Mission',
      title: 'LittleG 正在生成城市任務…',
      text: '先完成一張 City Mission Card，再延伸到分享、任務牆或證書桌。'
    },
    explore: {
      label: 'Explore Mode',
      focus: 'Place Explorer',
      title: 'LittleG 正在閱讀地點…',
      text: '正在把地點、交通、生活圈和附近任務放到同一圖通上。'
    },
    property: {
      label: 'Property Mode',
      focus: 'Family Fit',
      title: 'LittleG 正在比較生活圈…',
      text: '正在比較校網、交通和家庭需要。'
    },
    nature: {
      label: 'Nature Quest',
      focus: 'Nature Observation',
      title: 'LittleG 正在觀察自然線索…',
      text: '正在把山、水、林、田、湖、草、沙變成自然任務。'
    },
    professional: {
      label: 'Professional Review',
      focus: 'Ask GLG',
      title: 'LittleG 正在整理專業需求…',
      text: '需要測繪、GIS、估值、規劃或城市更新支援時，進入 GLG Path。'
    }
  };

  function q(root, selector) {
    return root ? root.querySelector(selector) : null;
  }

  function qa(root, selector) {
    return root ? Array.prototype.slice.call(root.querySelectorAll(selector)) : [];
  }

  function text(el, value) {
    if (el && typeof value === 'string') el.textContent = value;
  }

  function setThinking(root, mode) {
    var copy = MODE_COPY[mode] || MODE_COPY.explore;
    text(q(root, '[data-gcity-active-layer]'), copy.label);
    text(q(root, '[data-focus-label]'), copy.focus);
    text(q(root, '[data-thinking-title]'), copy.title);
    text(q(root, '[data-thinking-text]'), copy.text);

    var layer = q(root, '.gx952__thinking-layer');
    if (layer) {
      layer.hidden = false;
      window.setTimeout(function () {
        layer.hidden = true;
      }, 900);
    }
  }

  function setTool(root, button) {
    if (!button) return;
    var intent = button.getAttribute('data-gcity-intent') || 'explore';
    var stage = button.getAttribute('data-gcity-stage') || 'start';
    var tool = button.getAttribute('data-gcity-map-tool') || intent;

    root.setAttribute('data-active-intent', intent);
    root.setAttribute('data-active-stage', stage);
    root.setAttribute('data-active-tool', tool);

    qa(root, '[data-gcity-map-tool]').forEach(function (item) {
      var active = item === button;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', active ? 'true' : 'false');
    });

    setThinking(root, intent === 'missions' ? 'missions' : intent);
  }

  function launch(root, action) {
    var urls = {
      play: root.getAttribute('data-mission-url'),
      search: '#gcity-spatial-search-container',
      traffic: root.getAttribute('data-mission-url') + '?source=littleg-explore&intent=traffic',
      mission: root.getAttribute('data-mission-url'),
      wall: root.getAttribute('data-mission-wall-url'),
      dashboard: root.getAttribute('data-dashboard-url'),
      contest: root.getAttribute('data-contest-url')
    };

    if (action === 'search') {
      var input = document.querySelector('[data-search-input]');
      if (input) {
        input.focus();
        input.select();
      }
      return;
    }

    if (urls[action]) window.location.href = urls[action];
  }

  function closeInsight(root) {
    var insight = q(root, '.gx952__insight');
    if (insight) insight.classList.add('is-hidden');
  }

  function initWorkspace(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    var active = q(root, '[data-gcity-map-tool].is-active') || q(root, '[data-gcity-map-tool]');
    setTool(root, active);

    root.addEventListener('click', function (event) {
      var tool = event.target.closest('[data-gcity-map-tool]');
      if (tool && root.contains(tool)) {
        event.preventDefault();
        setTool(root, tool);
        return;
      }

      var launchButton = event.target.closest('[data-gcity-tool-launch]');
      if (launchButton && root.contains(launchButton)) {
        event.preventDefault();
        launch(root, launchButton.getAttribute('data-gcity-tool-launch'));
        return;
      }

      var close = event.target.closest('.gx952__insight-close');
      if (close && root.contains(close)) {
        event.preventDefault();
        closeInsight(root);
      }
    });

    root.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeInsight(root);
    });
  }

  function initSearch(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    var input = q(root, '[data-search-input]');
    var dropdown = q(root, '[data-search-suggestions]');
    var active = q(root, '.gcity-active-query');
    var bubble = q(root, '[data-guide-bubble]');
    var guide = q(root, '[data-guide-copy]');

    function showDropdown() {
      if (dropdown) dropdown.hidden = false;
      if (bubble) bubble.hidden = false;
    }

    function hideDropdown() {
      if (dropdown) dropdown.hidden = true;
    }

    root.addEventListener('focusin', function (event) {
      if (event.target.matches('[data-search-input]')) showDropdown();
    });

    root.addEventListener('submit', function (event) {
      var form = event.target.closest('[data-search-form]');
      if (!form) return;
      event.preventDefault();
      var value = input ? input.value.trim() : '';
      if (!value) {
        showDropdown();
        return;
      }
      if (active) {
        active.hidden = false;
        active.textContent = 'LittleG is exploring: ' + value;
      }
      if (guide) guide.textContent = root.getAttribute('data-explore-thinking') || 'LittleG is exploring this place.';
      hideDropdown();
    });

    root.addEventListener('click', function (event) {
      var chip = event.target.closest('.gcity-scene-chip');
      if (!chip || !root.contains(chip)) return;
      var scene = chip.getAttribute('data-scene') || chip.textContent.trim();
      var mode = chip.getAttribute('data-mode') || 'explore';
      if (input) input.value = scene;
      if (active) {
        active.hidden = false;
        active.textContent = 'Selected: ' + scene;
      }
      if (guide) {
        var attr = mode === 'property' ? 'data-property-thinking' : mode === 'professional' ? 'data-professional-thinking' : 'data-explore-thinking';
        guide.textContent = root.getAttribute(attr) || 'LittleG is preparing the next step.';
      }
      hideDropdown();
    });

    document.addEventListener('click', function (event) {
      if (!root.contains(event.target)) hideDropdown();
    });
  }

  function initPortal(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    var status = q(root, '[data-portal-status]');

    root.addEventListener('click', function (event) {
      var trigger = event.target.closest('[data-intent-trigger]');
      if (!trigger || !root.contains(trigger)) return;

      var card = trigger.closest('[data-intent-card]');
      if (!card) return;

      qa(root, '[data-intent-card]').forEach(function (item) {
        var active = item === card;
        item.classList.toggle('is-active', active);
        var button = q(item, '[data-intent-trigger]');
        if (button) button.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      var title = q(card, '.glg-portal-card__title');
      if (status) status.textContent = 'Mode: ' + (title ? title.textContent.trim() : card.getAttribute('data-intent'));
    });
  }

  function boot(context) {
    qa(context || document, '[data-module="map-workspace"]').forEach(initWorkspace);
    qa(context || document, '[data-littleg-search-root]').forEach(initSearch);
    qa(context || document, '[data-module="integrated-portal-bento"]').forEach(initPortal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(document); });
  } else {
    boot(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target || document);
  });
})();


(function(){
  'use strict';

  var routerInstances = new WeakMap();
  var labInstances = new WeakMap();
  var STORAGE_KEY = 'littleg_workspace_state_v1';

  function toArray(list){
    return Array.prototype.slice.call(list || []);
  }

  function nowIso(){
    return new Date().toISOString();
  }

  function safeParse(value, fallback){
    try {
      return value ? JSON.parse(value) : fallback;
    } catch (error) {
      return fallback;
    }
  }

  function readState(){
    try {
      return safeParse(window.sessionStorage.getItem(STORAGE_KEY) || window.localStorage.getItem(STORAGE_KEY), {});
    } catch (error) {
      return {};
    }
  }

  function writeState(patch){
    var next = Object.assign({}, readState(), patch || {}, { updatedAt: nowIso() });

    try {
      window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {}

    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    } catch (error) {}

    return next;
  }

  function dispatch(name, detail){
    if (!name || !window.CustomEvent) return;

    try {
      window.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
    } catch (error) {}
  }

  function createListenerStore(){
    var items = [];

    return {
      on: function(el, type, handler, options){
        if (!el || !type || !handler) return;
        var listenerOptions = options || false;
        el.addEventListener(type, handler, listenerOptions);
        items.push([el, type, handler, listenerOptions]);
      },
      clear: function(){
        items.forEach(function(item){
          item[0].removeEventListener(item[1], item[2], item[3]);
        });
        items = [];
      }
    };
  }

  function getReducedMotion(){
    return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  }

  function getClosestElement(node, selector){
    if (!node || !selector) return null;
    if (node.closest) return node.closest(selector);
    return null;
  }

  function getSectionIdFromNode(node){
    if (!node) return '';
    var section = getClosestElement(node, '[id^="shopify-section-"]');
    if (!section || !section.id) return '';
    return section.id.replace('shopify-section-', '');
  }

  function isSectionEventForNode(event, node){
    var target = event && event.target;
    if (!target || !node) return false;
    if (target === node) return true;
    if (target.contains && target.contains(node)) return true;
    if (node.contains && node.contains(target)) return true;
    return false;
  }

  function setText(el, value){
    if (!el) return;
    el.textContent = value || '';
  }

  function setOptionalText(el, value){
    if (!el) return;
    el.textContent = value || '';
    el.hidden = !value;
  }

  function setLink(el, href, text, suffix){
    if (!el) return;

    var resolvedHref = href || '#';
    el.setAttribute('href', resolvedHref);

    if (text) {
      el.textContent = String(text) + (suffix || '');
      el.removeAttribute('aria-disabled');
      el.removeAttribute('tabindex');
    } else {
      el.setAttribute('aria-disabled', 'true');
      el.setAttribute('tabindex', '-1');
    }
  }

  function escapeSelector(value){
    if (window.CSS && typeof window.CSS.escape === 'function') return window.CSS.escape(value);
    return String(value || '').replace(/[^a-zA-Z0-9_-]/g, '\\$&');
  }

  function emitWorkspaceState(patch){
    var state = writeState(patch);

    dispatch('littleg:workspace-state-change', state);

    return state;
  }

  function emitHandoff(patch){
    var state = emitWorkspaceState(Object.assign({}, patch || {}, {
      handoffAt: nowIso()
    }));

    dispatch('littleg:workspace-handoff', state);

    return state;
  }

  function initRouter(root){
    if (!root || routerInstances.has(root)) return;

    var cards = toArray(root.querySelectorAll('[data-route-card]'));
    var detail = root.querySelector('[data-route-detail]');
    var moreButton = root.querySelector('[data-route-more]');

    if (!cards.length || !detail) return;

    var listeners = createListenerStore();
    var sectionId = getSectionIdFromNode(root);
    var transitionTimer = null;

    var fields = {
      status: detail.querySelector('[data-detail-status]'),
      title: detail.querySelector('[data-detail-title]'),
      task: detail.querySelector('[data-detail-task]'),
      expandedText: detail.querySelector('[data-detail-expanded-text]'),
      capability: detail.querySelector('[data-detail-capability]'),
      capabilitySummary: detail.querySelector('[data-detail-capability-summary]'),
      primary: detail.querySelector('[data-detail-primary]'),
      secondary: detail.querySelector('[data-detail-secondary]'),
      tertiary: detail.querySelector('[data-detail-tertiary]')
    };

    function cleanup(){
      if (transitionTimer) {
        window.clearTimeout(transitionTimer);
        transitionTimer = null;
      }

      listeners.clear();
      detail.classList.remove('is-transitioning');
      routerInstances.delete(root);
    }

    function runTransition(){
      if (getReducedMotion()) return;

      if (transitionTimer) {
        window.clearTimeout(transitionTimer);
        transitionTimer = null;
      }

      detail.classList.remove('is-transitioning');

      window.requestAnimationFrame(function(){
        detail.classList.add('is-transitioning');
        transitionTimer = window.setTimeout(function(){
          detail.classList.remove('is-transitioning');
          transitionTimer = null;
        }, 920);
      });
    }

    function updateHistory(card){
      if (!card || !card.dataset.intent) return;

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('intent', card.dataset.intent);

        if (card.dataset.stage) url.searchParams.set('stage', card.dataset.stage);
        else url.searchParams.delete('stage');

        window.history.replaceState({}, '', url.toString());
      } catch (error) {}
    }

    function cardPayload(card){
      return {
        source: 'explore-router',
        sectionId: sectionId,
        role: 'route-selector',
        intent: card.dataset.intent || '',
        stage: card.dataset.stage || '',
        title: card.dataset.title || '',
        pro: card.dataset.pro || '',
        task: card.dataset.task || '',
        capability: card.dataset.capability || '',
        primaryLink: card.dataset.primaryLink || '',
        secondaryLink: card.dataset.secondaryLink || '',
        tertiaryLink: card.dataset.tertiaryLink || ''
      };
    }

    function activate(card, options){
      if (!card || !root.contains(card)) return;

      options = options || {};

      if (card.classList.contains('is-active') && options.skipSame !== false) return;

      root.setAttribute('data-active-intent', card.dataset.intent || '');
      root.setAttribute('data-active-stage', card.dataset.stage || '');
      root.setAttribute('data-workspace-state', 'route-selected');

      cards.forEach(function(item){
        var active = item === card;
        item.classList.toggle('is-active', active);
        item.setAttribute('data-active', active ? 'true' : 'false');
        item.setAttribute('aria-pressed', active ? 'true' : 'false');
      });

      setOptionalText(fields.status, card.dataset.pro);
      setText(fields.title, card.dataset.title);
      setText(fields.task, card.dataset.task);
      setText(fields.expandedText, card.dataset.expandedText);
      setText(fields.capability, card.dataset.capability);
      setText(fields.capabilitySummary, card.dataset.capabilitySummary);
      setLink(fields.primary, card.dataset.primaryLink, card.dataset.primaryLabel);
      setLink(fields.secondary, card.dataset.secondaryLink, card.dataset.secondaryLabel);
      setLink(fields.tertiary, card.dataset.tertiaryLink, card.dataset.tertiaryLabel, ' →');

      runTransition();

      var payload = cardPayload(card);
      emitWorkspaceState(payload);
      dispatch('littleg:explore-route-change', payload);

      if (!options.skipHistory) updateHistory(card);
    }

    cards.forEach(function(card){
      listeners.on(card, 'click', function(){
        activate(card, { skipSame: false });
      });

      listeners.on(card, 'keydown', function(event){
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          activate(card, { skipSame: false });
        }
      });
    });

    if (moreButton) {
      var moreLabel = root.dataset.moreRoutesLabel || moreButton.textContent.trim() || 'Show all options';
      var lessLabel = root.dataset.lessRoutesLabel || 'Show less';

      listeners.on(moreButton, 'click', function(){
        var expanded = root.classList.toggle('is-expanded');
        moreButton.setAttribute('aria-expanded', expanded ? 'true' : 'false');
        moreButton.textContent = expanded ? lessLabel : moreLabel;
      });
    }

    listeners.on(document, 'shopify:section:unload', function(event){
      if (isSectionEventForNode(event, root)) cleanup();
    });

    routerInstances.set(root, {
      cleanup: cleanup,
      activate: activate
    });

    var activeCard = cards.filter(function(card){
      return card.dataset.intent === root.dataset.currentIntent;
    })[0] || cards.filter(function(card){
      return card.classList.contains('is-active');
    })[0] || cards[0];

    activate(activeCard, { skipHistory: true, skipSame: false });
  }

  function initLab(root){
    if (!root || labInstances.has(root)) return;

    var cards = toArray(root.querySelectorAll('[data-lab-card]'));
    var listeners = createListenerStore();
    var sectionId = getSectionIdFromNode(root);

    function cleanup(){
      listeners.clear();
      labInstances.delete(root);
    }

    function selectCard(card, options){
      options = options || {};

      cards.forEach(function(item){
        item.classList.remove('is-selected');
        item.classList.remove('is-focused');
        item.setAttribute('data-selected', 'false');
      });

      if (!card || !root.contains(card)) return;

      card.classList.add('is-selected');
      card.classList.add('is-focused');
      card.setAttribute('data-selected', 'true');

      if (options.skipScroll) return;

      try {
        card.scrollIntoView({
          behavior: getReducedMotion() ? 'auto' : 'smooth',
          block: 'nearest',
          inline: 'center'
        });
      } catch (error) {}
    }

    function focusFromParams(){
      var params = null;

      try {
        params = new URLSearchParams(window.location.search || '');
      } catch (error) {
        params = null;
      }

      var focusedTool = params ? (params.get('tool') || params.get('intent') || '') : '';

      if (!focusedTool) return;

      selectCard(root.querySelector('[data-lab-card][data-intent="' + escapeSelector(focusedTool) + '"]'), { skipScroll: true });
    }

    function getLabTrigger(event){
      var target = event && event.target && event.target.closest ? event.target : null;
      var trigger = target ? target.closest('[data-action="start-lab-tool"]') : null;

      if (!trigger || !root.contains(trigger)) return null;

      return trigger;
    }

    function startTool(trigger){
      if (!trigger) return;
      var intent = trigger.getAttribute('data-intent') || '';
      var card = getClosestElement(trigger, '[data-lab-card]');

      selectCard(card);

      var payload = {
        source: 'explore-lab',
        sectionId: sectionId,
        role: 'tool-launcher',
        intent: intent,
        stage: 'tool',
        title: card ? (card.getAttribute('data-title') || '') : '',
        href: trigger.getAttribute('href') || ''
      };

      emitHandoff(payload);
      dispatch('littleg:lab-tool:start', payload);
    }

    listeners.on(root, 'click', function(event){
      startTool(getLabTrigger(event));
    });

    listeners.on(root, 'keydown', function(event){
      if (event.key !== 'Enter' && event.key !== ' ') return;

      var trigger = getLabTrigger(event);
      if (!trigger) return;

      event.preventDefault();
      startTool(trigger);
    });

    listeners.on(document, 'shopify:section:unload', function(event){
      if (isSectionEventForNode(event, root)) cleanup();
    });

    labInstances.set(root, {
      cleanup: cleanup,
      selectCard: selectCard
    });

    focusFromParams();
  }

  function syncExternalEvents(){
    if (syncExternalEvents.bound) return;
    syncExternalEvents.bound = true;

    window.addEventListener('littleg:place-selected', function(event){
      emitWorkspaceState(Object.assign({}, event.detail || {}, {
        source: 'place-preview',
        role: 'place-preview',
        stage: 'place-selected'
      }));
    });

    window.addEventListener('littleg:mission-started', function(event){
      emitWorkspaceState(Object.assign({}, event.detail || {}, {
        source: 'mission-runner',
        role: 'mission',
        stage: 'mission-started'
      }));
    });

    window.addEventListener('littleg:mission-complete', function(event){
      emitWorkspaceState(Object.assign({}, event.detail || {}, {
        source: event.detail && event.detail.source ? event.detail.source : 'littleg-progress',
        role: 'mission',
        stage: 'mission-complete'
      }));
    });
  }

  function initScope(scope){
    var context = scope || document;

    syncExternalEvents();

    if (context.matches && context.matches('[data-module="littleg-explore-cockpit"]')) initRouter(context);

    if (context.querySelectorAll) {
      toArray(context.querySelectorAll('[data-module="littleg-explore-cockpit"]')).forEach(initRouter);
    }

    if (context.matches && context.matches('[data-module="explore-lab"]')) initLab(context);

    if (context.querySelectorAll) {
      toArray(context.querySelectorAll('[data-module="explore-lab"]')).forEach(initLab);
    }
  }

  function destroyScope(scope){
    if (!scope) return;

    if (scope.matches && scope.matches('[data-module="littleg-explore-cockpit"]')) {
      var ownRouter = routerInstances.get(scope);
      if (ownRouter && ownRouter.cleanup) ownRouter.cleanup();
    }

    if (scope.querySelectorAll) {
      toArray(scope.querySelectorAll('[data-module="littleg-explore-cockpit"]')).forEach(function(root){
        var instance = routerInstances.get(root);
        if (instance && instance.cleanup) instance.cleanup();
      });
    }

    if (scope.matches && scope.matches('[data-module="explore-lab"]')) {
      var ownLab = labInstances.get(scope);
      if (ownLab && ownLab.cleanup) ownLab.cleanup();
    }

    if (scope.querySelectorAll) {
      toArray(scope.querySelectorAll('[data-module="explore-lab"]')).forEach(function(root){
        var instance = labInstances.get(root);
        if (instance && instance.cleanup) instance.cleanup();
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function(){
      initScope(document);
    }, { once: true });
  } else {
    initScope(document);
  }

  document.addEventListener('shopify:section:load', function(event){
    initScope(event.target || document);
  });

  document.addEventListener('shopify:section:unload', function(event){
    destroyScope(event.target);
  });

  window.LittleGExploreLab = window.LittleGExploreLab || {};
  window.LittleGExploreLab.version = 'v95-workspace-contract';
  window.LittleGExploreLab.init = initScope;
  window.LittleGExploreLab.destroy = destroyScope;
  window.LittleGExploreLab.readState = readState;
  window.LittleGExploreLab.writeState = emitWorkspaceState;
  window.LittleGExploreLab.handoff = emitHandoff;
})();